import React from 'react';
import {observer} from 'mobx-react';
import {NewLiveCasinoConfiguration} from '../../../services/configurations/config-data-sections/arenas.configuration';
import {TopImageComponent} from '../../top-image/top-image.component';
import {SeoBreadCrumbsComponent} from '../seo-bread-crumbs/seo-bread-crumbs.component';
import {LiveCasinoArenaNavbar} from "./live-casino-arena-navbar/live-casino-arena-navbar.component";
import {LiveCasinoArenaGrid} from "./live-casino-arena-grid/live-casino-arena-grid.component";
import {OrbitComponentWithState} from '../../base-components/orbit-component-with-state/orbit-component-with-state';
import {IStickyHandler} from "../../sticky-handler/sticky-handler.interface";
import {LiveCasinoArenaNavbarButton} from "./live-casino-arena-navbar/live-casino-arena-navbar-button.component";
import {LIVE_CASINO_PAGE_WRAPPER} from '../../../themes/css-global-classes';
import {LinkToOfferComponent} from "../../link-to-offer/link-to-offer.component";
import {DailyDealComponent} from "../../daily-deal/daily-deal.component";
import {FreeToPlayAnimatedIconComponent} from '../../free-to-play-animated-icon/free-to-play-animated-icon.component';

export interface NewLiveCasinoArenaComponentProps {
  configs: NewLiveCasinoConfiguration;
  arenaName: string;
}

export interface INewLiveCasinoArenaComponentState {
}

const SEO_CATEGORY = 'LIVE_CASINO_NEW';

export const NewLiveCasinoArenaComponent = observer(
  class NewLiveCasinoArenaComponent extends OrbitComponentWithState<NewLiveCasinoArenaComponentProps, INewLiveCasinoArenaComponentState> {

    private _stickyHandler: IStickyHandler;
    private _topImageRef = React.createRef<HTMLDivElement>();

    componentDidMount() {
      super.componentDidMount();
    }

    private get stickyHandler(): IStickyHandler {
      if (!this._stickyHandler && this._topImageRef?.current) {
        this._stickyHandler = this.services.stickyHandlerFactory.createStickyHandler();
      } else {
        return this.services.stickyHandlerFactory.createStickyHandler();
      }

      return this._stickyHandler;
    }

    private _renderLinkToOffer() {
      return (
        <>
          <LinkToOfferComponent linkToOfferConfig={this.props.configs.linkToOffer} />
          <FreeToPlayAnimatedIconComponent />
        </>
      );
    }

    render() {
      return (
        <div className={`${LIVE_CASINO_PAGE_WRAPPER} cy-new-live-casino`}>

          <TopImageComponent
            image={this.props.configs.topImage}
            topImageRef={this._topImageRef}
            animatedBanner={this.props.configs.animatedTopImage}
            CMSbanner={this.props.configs.CMSbanner}
          />

          {
            this.services.liveTableFeeds.isNavbarVisible && <LiveCasinoArenaNavbar
              title={this.props.configs.title}
              configs={this.services.liveTableFeeds.liveArenaTabsConfiguration}
              stickyHandler={this.stickyHandler}
              FilterButtonComponent={LiveCasinoArenaNavbarButton}
            />
          }

          <LiveCasinoArenaGrid
            seoCategory={SEO_CATEGORY}
            promotionalBannerConfig={this.props.configs.promotionalBanner}
            useAISortedList={this.props.configs.useAISortedList} />

          <SeoBreadCrumbsComponent arenaName={this.props.arenaName} config={this.props.configs.seoSection} />

          {this._renderLinkToOffer()}
          <DailyDealComponent />
        </div>
      );


    }
  }
);
